import Box from "@amzn/meridian/esm/components/box";
import Column from "@amzn/meridian/esm/components/column";
import Icon from "@amzn/meridian/esm/components/icon";
import Row from "@amzn/meridian/esm/components/row";
import Text from "@amzn/meridian/esm/components/text";
import Theme from "@amzn/meridian/esm/components/theme";
import clipboardTokens from "@amzn/meridian-tokens/base/icon/clipboard";
import flashTokens from "@amzn/meridian-tokens/base/icon/flash";
import chatTokens from "@amzn/meridian-tokens/base/icon/chat";
import { THEME_COLOR } from "../../constants";

const SECTION_ICONS = {
  context: clipboardTokens,
  topics: flashTokens,
  now: chatTokens,
};

const SectionCard = ({ type, title, content }) => {
  const iconTokens = SECTION_ICONS[type] || clipboardTokens;

  return (
    <Column spacing="300">
      <Row spacing="300" alignmentVertical="center">
        <div style={{
          width: 28,
          height: 28,
          borderRadius: "50%",
          backgroundColor: "#D2F3E8",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
        }}>
          <div style={{ transform: "scale(0.60)" }}>
            <Theme tokens={{ iconColorSecondary: THEME_COLOR.SEAFOAM_GREEN }}>
              <Icon tokens={iconTokens} color="secondary" />
            </Theme>
          </div>
        </div>
        <Text fontFamily="amazonEmber" type="h100">{title}</Text>
      </Row>
      <Theme tokens={{ boxBorderColorOutline: "#E2E6E8", boxBorderRadiusOutline: 12 }}>
        <Box type="outline" spacingInset="400">
          <Column spacing="200">
            {Array.isArray(content) ? (
              content.map((item, i) => (
                <Column key={i} spacing="100">
                  {item.heading && (
                    <Row spacing="200" alignmentVertical="center">
                      <div style={{ width: 6, height: 6, borderRadius: "50%", backgroundColor: "#006D5B", flexShrink: 0 }} />
                      <Text fontFamily="amazonEmber" type="h50">{item.heading}</Text>
                    </Row>
                  )}
                  {item.body && (
                    <Row spacing="200" alignmentVertical="top">
                      <div style={{ width: 6, flexShrink: 0 }} />
                      <Text fontFamily="amazonEmber" type="b200" color="secondary">
                        {item.body}
                      </Text>
                    </Row>
                  )}
                </Column>
              ))
            ) : (
              <Text fontFamily="amazonEmber" type="b200">
                {content}
              </Text>
            )}
          </Column>
        </Box>
      </Theme>
    </Column>
  );
};

export default SectionCard;
